import { Resource } from "src/app/core/jsonapi/resource";
import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Dataset } from "./dataset";
import { User } from "../../users/_types/user";

export class Report extends Resource {
    public override type = 'reports';  

    @prop()
    @required()
    public name!: string;   
    
     @prop()
    public description?: string;

    @prop()
    @required()
    public datasetId!: string;
    
    public dataset!: Dataset;
        
    @prop()
    public config!: string;
    
    @prop()
    @required()
    public active: boolean = true;

    @prop()
    public reportConfig!: any;

    @prop()
    public useSnapshot: boolean = false;

    @prop()
    @required()
    public isSystem: boolean = false;

    @propObject()
    public createdByUser!: User;
}